import { Layout } from 'antd';
import type { ReactNode } from 'react';
import { Outlet } from 'react-router-dom';
import { AppTopBar } from './AppTopBar';
import { AppSidebar } from './AppSidebar';

const { Header, Sider, Content } = Layout;

/**
 * App shell — top bar, sidebar, main content area.
 * See docs/ui-ux-design.md §4.1, §4.2.
 */
export function AppShell({ children }: { children?: ReactNode }) {
  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Header style={{ padding: 0, borderBottom: '1px solid #e5e7eb' }}>
        <AppTopBar />
      </Header>
      <Layout>
        <Sider
          width={240}
          breakpoint="lg"
          collapsedWidth={64}
          style={{ borderRight: '1px solid #e5e7eb' }}
        >
          <AppSidebar />
        </Sider>
        <Content style={{ overflow: 'auto' }}>{children ?? <Outlet />}</Content>
      </Layout>
    </Layout>
  );
}